import $ from 'jquery';

import { createUuidV4 } from '../../utils/security.utils';
import { logData } from '../../utils/debug.util';
import storageService from '../../services/storage.service';
import { IMetadata } from '../../models/metadata.model';
import { IMBEE_KEY } from '../../constants/env';
import { logoChat } from '../../assets/images/images';

declare const window: Window &
  typeof globalThis & {
    imbeeOptions?: any;
    imbeeShow?: any;
  };

// ─── Animación del chatbot ────────────────────────────────────────────────────

let chatbotAnimation: any;
const timeToBounce = 15000;
const timeOpenCloseHead = 250;

const firstIcon = logoChat['00000016'];
let currentIcon = '';

export let globalChatVariables: ImbeeChatVariables = [];

export function setGlobalChatVariables(vars: ImbeeChatVariables): void {
  globalChatVariables = vars;
}

export function setGlobalChatIcon(icon: string): void {
  currentIcon = icon;
}

let currentBgCol: string = '#0094D9';

export function setGlobalChatBgCol(bgCol: string): void {
  currentBgCol = bgCol;
}

export function chatbotInitialAnimation() {
  setTimeout(function () {
    $('.c-chatbot').css('opacity', 1).addClass('bounceInUp');
    setTimeout(function () {
      $('.c-chatbot').removeClass('bounceInUp');
      chatbotGeneralAnimation();
    }, 1000);
  }, 1000);
}

export function chatbotGeneralAnimation() {
  clearTimeout(chatbotAnimation);
  chatbotAnimation = setTimeout(function () {
    $('.c-chatbot').addClass('bounce');
    setTimeout(function () {
      $('.c-chatbot').removeClass('bounce');
      chatbotGeneralAnimation();
    }, 1000);
  }, timeToBounce);
}

export function handleChatOpening(logoForChat: string, chatVariables?: ImbeeChatVariables) {
  const c_chatbot = $('.c-chatbot');
  globalChatVariables = chatVariables || [];

  if (logoForChat !== currentIcon) {
    currentIcon = logoForChat;
  }

  if (!currentIcon) {
    currentIcon = firstIcon;
  }

  startImbeeChat(currentIcon, 'imbee', globalChatVariables);

  $(c_chatbot).slideUp(timeOpenCloseHead, function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    $(that)
      .removeClass('c-chatbot--no-head')
      .removeClass('c-chatbot--unread-messages')
      .addClass('c-chatbot--opened')
      .slideDown(timeOpenCloseHead, function () {});
    setTimeout(function () {
      $(that).trigger('chatbot-message-scrolltoend');
    }, 1);
  });
}

$(function () {
  $('body')
    // External events
    .on('click', '.e-chatbot--toggle', function (e) {
      const c_chatbot = $('.c-chatbot');
      e.preventDefault();
      if (c_chatbot.hasClass('c-chatbot--opened')) {
        c_chatbot.trigger('chatbot-minimize');
      } else {
        c_chatbot.trigger('chatbot-open');
      }
      return false;
    })
    .on('click', '.e-chatbot--open', function (e) {
      const c_chatbot = $('.c-chatbot');
      e.preventDefault();
      c_chatbot.trigger('chatbot-open');
      return false;
    })
    // Internal events
    .on('chatbot-open', '.c-chatbot', function () {
      handleChatOpening(currentIcon, globalChatVariables);
    })
    .on('chatbot-minimize', '.c-chatbot', function () {
      $(this).slideUp(timeOpenCloseHead, function () {
        $(this).removeClass('c-chatbot--opened').slideDown(timeOpenCloseHead);
      });
    })
    .on('chatbot-set-unread', '.c-chatbot', function () {
      $(this).addClass('c-chatbot--unread-messages');
    })
    // General Events
    .on('mousemove', function () {
      chatbotGeneralAnimation();
    })
    .on('keyup', function () {
      chatbotGeneralAnimation();
    });
});

// ─── Inicialización de Imbee ──────────────────────────────────────────────────

function isValidString(str: string | null | undefined): boolean {
  return str !== null && str !== undefined && str.trim() !== '';
}

const getChatFlow = (pathname: string): string => {
  if (pathname.includes('confirmation')) return 'missingCrane';
  if (pathname.includes('unregistered') || pathname.includes('assistance')) return 'assistanceQuery';
  return 'generalChat';
};

export type ImbeeChatVariables = [string, unknown][];

export const startImbeeChat = (profileImageUrl: string, divId = 'imbee', chatVariables?: ImbeeChatVariables): void => {
  const baseUrl = window.location.origin;
  const overrideCss = `@import url('${baseUrl}/chatStyle.css');
:root {
  --main-input-send-icon-color: ${currentBgCol};
  --main-input-send-icon-hover-color: ${currentBgCol};
  --main-user-bg-color: ${currentBgCol};
  --buttons-font-color: ${currentBgCol};
}`;
  const blob = new Blob([overrideCss], { type: 'text/css' });
  const cssUrl = URL.createObjectURL(blob);

  logData('startImbeeChat', { profileImageUrl, chatVariables, cssUrl });

  storageService.getItem<IMetadata>('metaData').then((metadata) => {
    window.imbeeOptions = {
      divId,
      myCss: cssUrl,
      init: (IMbee: any) => initImbee(IMbee, profileImageUrl, metadata, chatVariables),
    };

    // El script solo se añade una vez listo window.imbeeOptions, para evitar una condición de carrera
    const script = document.createElement('script');
    script.src = IMBEE_KEY || '';
    document.head.appendChild(script);
  });
};

function initImbee(
  IMbee: any,
  profileImageUrl: string,
  metadata: IMetadata | null,
  chatVariables?: ImbeeChatVariables,
): void {
  const wsUrl = 'https://api.imbee.me';
  const xmppUrl = 'https://messenger.imbee.me';
  const apikey = import.meta.env.VITE_IMBEE_API_KEY || '';

  const providerCode = storageService.getLocalItem<string>('providerCode') || undefined;

  const nif = metadata?.userIdentification;
  const assistance = metadata?.assistanceNumber;

  let uniqueIdsha: string;
  if (isValidString(nif) && isValidString(assistance)) {
    uniqueIdsha = `nif-${nif}-assistance-${assistance}`;
  } else if (isValidString(nif)) {
    uniqueIdsha = `nif-${nif}`;
  } else if (isValidString(assistance)) {
    uniqueIdsha = `assistance-${assistance}`;
  } else {
    uniqueIdsha = createUuidV4();
  }

  const botIdsha = import.meta.env.VITE_IMBEE_BOT_KEY || '';
  const environment = 2;
  const placeholderText = '...';

  IMbee.init(wsUrl, xmppUrl, environment, apikey, placeholderText);

  // eslint-disable-next-line
  IMbee.externalUserRegistration(uniqueIdsha, function (data: any) {
    // eslint-disable-next-line
    IMbee.chatCreate(botIdsha, function (conversationId: string, created: boolean) {
      const options = {
        conversationTarget: conversationId,
        centeredChat: false,
        conversationLeftProfile: profileImageUrl,
        singleAvatar: true,
        chatViewVersion: 'new',
        toggleTime: true,
        copyButton: true,
      };
      const app = IMbee.getApp(options);
      app.start();

      const content = {
        type: 'message',
        plainText: 'msg invisible',
      };

      const flow = {
        label: 'flow',
        value: getChatFlow(location.pathname),
      };

      let metadataObj: any;
      if (metadata) {
        const variables = Object.entries(metadata).map(([key, value]) => ({ label: key, value }));

        metadataObj = {
          variables: variables.concat([flow]),
        };
      }

      if (chatVariables?.length && metadataObj) {
        chatVariables.forEach(([label, value]) => metadataObj.variables.push({ label, value }));
      } else if (chatVariables?.length) {
        metadataObj = {
          variables: [flow, ...chatVariables.map(([label, value]) => ({ label, value }))],
        };
      }

      if (providerCode && metadataObj) {
        metadataObj.variables.push({ label: 'entidad', value: providerCode });
      } else if (providerCode) {
        metadataObj = {
          variables: [
            flow,
            { label: 'entidad', value: providerCode },
            ...(chatVariables?.map(([label, value]) => ({ label, value })) || []),
          ],
        };
      }

      const postbackMsg = '{"POSTBACK_INITCHAT":{"browserInfo":""}}';
      app.sendMessageWithFlags(conversationId, content, postbackMsg, IMbee.MESSAGE_FLAG.INVISIBLE, metadataObj);
    });
  });

  if (window.imbeeShow) {
    window.imbeeShow();
  }
}
